module.exports = __webpack_public_path__ + "img/icon_map_2_hg_c.8be1c08d.png";